import React from "react";

const LogOutPopUp = ({ setOpenLogoutLink, signOut, openLogoutLink }) => {
  const triangleCustomStyle = {
    backgroundColor: "#fff",
    clipPath: "polygon(50% 0, 100% 100%, 0 100%)",
    width: "0.8vw",
    height: "0.5vw",
    zIndex: "999999999999",
    marginBottom: "-0.05vw",
  };

  const insideTriangle = {
    position: "absolute",
    top: "0.16vh",
    marginLeft: "0.06vw",
    backgroundColor: "#222",
    clipPath: "polygon(50% 0, 100% 100%, 0 100%)",
    width: "0.7vw",
    height: "0.45vw",
    zIndex: "99999999999",
  };

  return (
    <>
      {openLogoutLink && (
        <div
          style={{
            position: "fixed",
            width: "100%",
            height: "100vh",
            top: 0,
            left: 0,
            zIndex: 99999,
            pointerEvents: "all",
          }}
          onClick={() => setOpenLogoutLink(false)}
        />
      )}
      <div
        style={{
          position: "absolute",
          top: "3vh",
          zIndex: 99999999,
          width: "max-content",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div style={triangleCustomStyle}>
          <div style={insideTriangle}></div>
        </div>
        <div
          style={{
            background: "#222",
            zIndex: 99999999,
            width: "max-content",
            padding: "0.6vw",
            border: "1px solid #fff",
            pointerEvents: "auto",
          }}
        >
          <p
            style={{
              color: "#fff",
              margin: 0,
              fontSize: "0.75vw",
              cursor: "pointer",
              width: "max-content",
            }}
            onClick={() => {
              setOpenLogoutLink(false);
              signOut();
            }}
          >
            logout
          </p>
        </div>
      </div>
    </>
  );
};

export default LogOutPopUp;
